<template>
  <div class="schools-dropdown">
    <PillDropdown
      :name="$t('search.schoolsDropdownName')"
      :allow-multi-select="true"
      :options="schoolsState"
      :show-search="true"
      :show-select-all="true"
      @clear-filters="clearFilters"
      @apply-filters="applyFilters"
      @filter-applied="$emit('filterApplied', $event)"
    >
    </PillDropdown>
  </div>
</template>

<script setup>
import { useStore } from 'vuex';
import { useSearchFilters } from '@/composables/useSearchFilters';
import PillDropdown from './PillDropdown.vue';
import { trackOrgFilterApplied } from '@/helpers/searchAnalytics';

defineEmits(['filterApplied']);
const route = useRoute();
const store = useStore();
const { schoolsState, initializeSchools, selectedSchools } = useSearchFilters();

const searchOrgs = store.state.settings?.searchOrgs || [];
const allOrgs = store.state.organizations || [];

let searchableOrgs = [];
if (searchOrgs.length > 0) {
  searchableOrgs = allOrgs.filter((org) => searchOrgs.includes(org.id));
} else {
  searchableOrgs = allOrgs;
}

const formattedOrgs = searchableOrgs.map((school) => ({
  name: school.name,
  org_id: school.id,
  checked: false,
}));

initializeSchools(formattedOrgs);

function clearFilters() {
  const newQuery = { ...route.query };
  delete newQuery.secondary_organizations;
  navigateTo({ query: newQuery }, { replace: true });
}

function applyFilters() {
  if (selectedSchools.value.length > 0) {
    trackOrgFilterApplied(selectedSchools.value);
  }

  const newQuery = { ...route.query, secondary_organizations: selectedSchools.value };
  navigateTo({ query: newQuery }, { replace: true });
}
</script>
